import { render } from "./FpuiBanner.vue?vue&type=template&id=101d6a8f"
import script from "./FpuiBanner.vue?vue&type=script&lang=js"
export * from "./FpuiBanner.vue?vue&type=script&lang=js"

import "./FpuiBanner.vue?vue&type=style&index=0&id=101d6a8f&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__